module.exports = "../images/arrow-lb-left-hover.png";